import React from 'react';

/** Lazy ClientComputedShare (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedShare = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-share' */
            './ClientComputedShare'
        ),
);
